import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { jsx, jsxs } from 'react/jsx-runtime.js';
import React__default from 'react';
import { Button } from '@jetbrains/ring-ui/dist/button/button.js';
import ButtonGroup from '@jetbrains/ring-ui/dist/button-group/button-group.js';
import { insertSpacesInStr } from '../../utils/string.js';
import styles from './Tabs.module.css.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Tabs = /*#__PURE__*/React__default.memo(function (props) {
  var _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    onSelectTab = props.onSelectTab,
    options = props.options,
    selected = props.selected;
  var handleSelectTab = function handleSelectTab(id) {
    return function () {
      return onSelectTab(id);
    };
  };
  return jsx(ButtonGroup, {
    className: styles.container,
    children: options.map(function (option) {
      return jsxs(Button, _objectSpread(_objectSpread({
        className: styles.button,
        active: selected === option.id,
        disabled: disabled,
        onClick: handleSelectTab(option.id)
      }, option.htmlProps), {}, {
        children: [option.title, !!option.count && jsx("span", {
          className: styles.count,
          children: insertSpacesInStr(String(option.count), 3)
        })]
      }), option.id);
    })
  });
});

export { Tabs };
